import React from 'react'
import ViewIndividualMembersForm from '../../features/viewIndividualMember/ViewIndividualMembersForm'

const ViewIndividualMember = () => {
  return (
    <div><ViewIndividualMembersForm /></div>
  )
}

export default ViewIndividualMember